import { DropdownSelectionEvent, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutResponsibilityCodeUser } from "./autogen/AutogenLayoutResponsibilityCodeUser";
import { CompanySettings } from "@mcleod/core";

const PAY_COMMISSION_CODE_ASSIGNED = "A";
const PAY_COMMISSION_OPERATIONS = "O";
const PAY_COMMISSION_DISPATCHER = "D";
const PAY_COMMISSION_NEVER = "N";

export class ResponsibilityCodeUser extends AutogenLayoutResponsibilityCodeUser {

    override onLoad() {
        const isCommissionEnabled: boolean = CompanySettings.get()?.commission_enabled;
        const shouldShowCommissionFields: boolean = !!isCommissionEnabled;
        this.textboxPayCommissionsWhen.visible = shouldShowCommissionFields;
        this.textboxCommOrderEntryRole.visible = shouldShowCommissionFields;
        this.textboxCommDispatcherRole.visible = shouldShowCommissionFields;
        this.textboxEffectiveDate.visible = shouldShowCommissionFields;
    }

    textboxRowUserIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.operation = "Responsibility-Code"
    }

    textboxPayCommissionsWhenAfterDropdownSelection(event: DropdownSelectionEvent) {
        if (event.hasSelection()) {
            const selectedValue = event.selection.value;
            if (PAY_COMMISSION_NEVER === selectedValue) {
                this.textboxCommOrderEntryRole.enabled = false;
                this.textboxCommDispatcherRole.enabled = false;
                this.textboxEffectiveDate.enabled = false;
                this.textboxCommOrderEntryRole.required = false;
                this.textboxCommDispatcherRole.required = false;
                this.textboxEffectiveDate.required = false;
                this.mainDataSource.activeRow.set("comm_order_entry_role", null);
                this.mainDataSource.activeRow.set("comm_dispatcher_role", null);
                this.mainDataSource.activeRow.set("effective_date", null);
            }
            if (PAY_COMMISSION_DISPATCHER === selectedValue) {
                this.textboxCommOrderEntryRole.enabled = false;
                this.textboxCommDispatcherRole.enabled = true;
                this.textboxEffectiveDate.enabled = true;
                this.textboxCommOrderEntryRole.required = false;
                this.textboxCommDispatcherRole.required = true;
                this.textboxEffectiveDate.required = true;
                this.mainDataSource.activeRow.set("comm_order_entry_role", null);
            }
            if (PAY_COMMISSION_OPERATIONS === selectedValue) {
                this.textboxCommOrderEntryRole.enabled = true;
                this.textboxCommDispatcherRole.enabled = false;
                this.textboxEffectiveDate.enabled = true;
                this.textboxCommOrderEntryRole.required = true;
                this.textboxCommDispatcherRole.required = false;
                this.textboxEffectiveDate.required = true;
                this.mainDataSource.activeRow.set("comm_dispatcher_role", null);
            }
            if (PAY_COMMISSION_CODE_ASSIGNED === selectedValue) {
                this.textboxCommOrderEntryRole.enabled = true;
                this.textboxCommDispatcherRole.enabled = true;
                this.textboxEffectiveDate.enabled = true;
                this.textboxCommOrderEntryRole.required = true;
                this.textboxCommDispatcherRole.required = true;
                this.textboxEffectiveDate.required = true;
            }
        }
    }

}
